import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const LoadingState: React.FC = () => (
  <LoadingStateWrapper className={styles.skeletonContainer}>
    <div className={styles.skeletonTitleContainer}>
      <Skeleton variant="rectangular" height="20px" width="50%" animation="pulse" />
    </div>

    <div className={styles.skeletonTabContainer}>
      <Skeleton variant="rectangular" height="21px" animation="pulse" />
    </div>
  </LoadingStateWrapper>
);

export default LoadingState;
